// extracted by mini-css-extract-plugin
var _1 = "n_aX_";
var _2 = "x5fem";
var _3 = "ICWx0";
var _4 = "OPkkp";
var _5 = "ifnV9";
var _6 = "XlIKG";
var _7 = "Mahq2";
var _8 = "_34_3U";
var _9 = "qBA8l";
export { _1 as "box-shadow-100", _2 as "box-shadow-200", _3 as "box-shadow-300", _4 as "box-shadow-400", _5 as "clearfix", _6 as "disable-user-select", _7 as "reset", _8 as "reset-box-sizing", _9 as "reset-font-smoothing" }
